module.exports = __webpack_public_path__ + "img/94838.050886a8.svg";